import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type SurveyFilterInformation_SurveyFiltersQuery as Data } from '~/gql/graphql'

import { useSurveyFiltersQueryKey } from './useSurveyFiltersQueryKey'

export const useSurveyFiltersQueryData = () => {
  const queryKey = useSurveyFiltersQueryKey()

  const { data } = useQuery<Data>({ enabled: false, queryKey })

  return React.useMemo(() => data?.surveyFilters ?? [], [data])
}
